
















































































import { Validator } from 'vee-validate';
import { Component, Inject, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class NationalInsuranceNumberInput extends Vue {
    @Inject('$validator') public $validator!: Validator;
    @Prop({ required: true }) private nationalInsuranceNumber!: string | null;

    private partOne: string | null = this.nationalInsuranceNumber != null ? this.nationalInsuranceNumber.substr(0, 2) : null;
    private partTwo: string | null = this.nationalInsuranceNumber != null ? this.nationalInsuranceNumber.substr(3, 2) : null;
    private partThree: string | null = this.nationalInsuranceNumber != null ? this.nationalInsuranceNumber.substr(6, 2) : null;
    private partFour: string | null = this.nationalInsuranceNumber != null ? this.nationalInsuranceNumber.substr(9, 2) : null;
    private partFive: string | null = this.nationalInsuranceNumber != null ? this.nationalInsuranceNumber.substr(12, 1) : null;
    private isRequired: boolean = this.nationalInsuranceNumber != null && this.nationalInsuranceNumber.length > 0;

    private get nationalInsuranceNumberOne(): string | null {
        return this.partOne;
    }

    private set nationalInsuranceNumberOne(value: string | null) {
        this.partOne = value != null ? value.toUpperCase() : null;
    }

    private get nationalInsuranceNumberTwo(): string | null {
        return this.partTwo;
    }

    private set nationalInsuranceNumberTwo(value: string | null) {
        this.partTwo = value != null ? value.toUpperCase() : null;
    }

    private get nationalInsuranceNumberThree(): string | null {
        return this.partThree;
    }

    private set nationalInsuranceNumberThree(value: string | null) {
        this.partThree = value != null ? value.toUpperCase() : null;
    }

    private get nationalInsuranceNumberFour(): string | null {
        return this.partFour;
    }

    private set nationalInsuranceNumberFour(value: string | null) {
        this.partFour = value != null ? value.toUpperCase() : null;
    }

    private get nationalInsuranceNumberFive(): string | null {
        return this.partFive;
    }

    private set nationalInsuranceNumberFive(value: string | null) {
        this.partFive = value != null ? value.toUpperCase() : null;
    }

    @Watch('partOne')
    private async onPartOneChangedAsync(): Promise<void> {
        this.validateNationalInsuranceNumber();
    }

    @Watch('partTwo')
    private async onPartTwoChangedAsync(): Promise<void> {
        this.validateNationalInsuranceNumber();
    }

    @Watch('partThree')
    private async onPartThreeChangedAsync(): Promise<void> {
        this.validateNationalInsuranceNumber();
    }

    @Watch('partFour')
    private async onPartFourChangedAsync(): Promise<void> {
        this.validateNationalInsuranceNumber();
    }

    @Watch('partFive')
    private async onPartFiveChangedAsync(): Promise<void> {
        this.validateNationalInsuranceNumber();
    }

    private async validateNationalInsuranceNumber(): Promise<void> {
        await this.$validator.validateAll('national-insurance-number');

        this.isRequired =
            (this.partOne != null && this.partOne.length > 0) ||
            (this.partTwo != null && this.partTwo.length > 0) ||
            (this.partThree != null && this.partThree.length > 0) ||
            (this.partFour != null && this.partFour.length > 0) ||
            (this.partFive != null && this.partFive.length > 0);


        if (this.partOne == null || !this.partOne.match('[A-Z]{2}')) {
            this.$emit('change', null);
            return;
        }

        if (this.partTwo == null || !this.partTwo.match('[0-9]{2}')) {
            this.$emit('change', null);
            return;
        }

        if (this.partThree == null || !this.partThree.match('[0-9]{2}')) {
            this.$emit('change', null);
            return;
        }

        if (this.partFour == null || !this.partFour.match('[0-9]{2}')) {
            this.$emit('change', null);
            return;
        }

        if (this.partFive == null || !this.partFive.match('[A-Z]{1}')) {
            this.$emit('change', null);
            return;
        }

        this.$emit('change', `${this.partOne}-${this.partTwo}-${this.partThree}-${this.partFour}-${this.partFive}`);
    }
}
